module.exports = __webpack_public_path__ + "static/media/project-thumbnail11.8d017ec3.jpg";